"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearch = exports.useFuzzy = void 0;
var fuse_js_1 = __importDefault(require("fuse.js"));
var react_1 = require("react");
function useFuzzy(data, options) {
    var _a = (0, react_1.useState)(''), keyword = _a[0], setKeyword = _a[1];
    var resetSearch = function () { return setKeyword(''); };
    var searcher = (0, react_1.useMemo)(function () {
        var defaultOptions = { tokenize: true, threshold: 0.2 };
        return new fuse_js_1.default(data, __assign(__assign({}, defaultOptions), options));
    }, [data, options]);
    var result = keyword
        ? (searcher.search(keyword) || []).map(function (r) { return (__assign(__assign({}, r.item), { matches: r.matches })); })
        : data;
    return {
        keyword: keyword,
        resetSearch: resetSearch,
        result: result,
        search: setKeyword,
    };
}
exports.useFuzzy = useFuzzy;
exports.useSearch = useFuzzy;
//# sourceMappingURL=index.js.map